import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyClipMenuTabBlock = styled.div``;

const MyClipMenuUlBlock = styled.ul`
    
    ${isMobileOnly?`
        margin-bottom: 5vw;    
  `:`
        margin-bottom: 50px;
  `};
`;

const MyClipMenuLiBlock = styled.li`
    float: left;
    width: 33.33%;
    color: ${prods => prods.active ? '#fff' : '#999'};
    background-color: ${prods => prods.active ? '#111' : '#fff'};
    border: 1px solid #ccc;
    border-left: none;
    font-size: 18px;
    text-align: center;
    padding: 15px 0px;

    :first-child {
        border-left: 1px solid #ccc;
    }

    cursor: pointer;
`;


const MyClipMenuTab = ({ active, clipinfo, clickHandler }) => {

    const [menu, setMenu] = useState(null);

    useEffect(() => {
        let menutitle = [
            { title: '브랜드', cnt: 0 }, { title: '상품', cnt: 0 }/* , { title: '콘텐츠', cnt: 0 } */
        ];
        if (clipinfo !== null) {
            menutitle[0].cnt = clipinfo.brand.length + clipinfo.nobrand.length;
            //상품 개수
            let count = 0;
            for(var i = 0; i < clipinfo.prodbrand.length ; i++){
                count += clipinfo.prodbrand[i].countprdt;
            }
            menutitle[1].cnt = count;
            //menutitle[2].cnt = clipinfo.spaceCount;
        }

        setMenu(menutitle);

    }, [clipinfo])

    const handleClick = (param) => {
        clickHandler(param);
    }

    if (menu === null) {
        return <MyClipMenuTabBlock />
    }

    return (
        <MyClipMenuTabBlock>
            <MyClipMenuUlBlock className="clearfix">
                {
                    menu.map((curitem, index) => {
                        return (<MyClipMenuLiBlock key={index} active={index === active} onClick={() => { handleClick(index) }}>
                            {curitem.title} ( <span>{curitem.cnt}</span> )
                        </MyClipMenuLiBlock>)
                    })
                }
            </MyClipMenuUlBlock>
        </MyClipMenuTabBlock>
    );
};

export default MyClipMenuTab;
